<script>
import { 站點 } from "@/libs/const";
import axios from "axios";
import _ from "lodash";
export default {
  computed: {
    stationPath() {
      return 站點[this.$store.state.station.type];
    },
    isQuizCompleted() {
      return !!this.$store.state.station.person?.report?.外部問卷 || false;
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    async submit() {
      let data = {
        query: _.pick(this.$store.state.station.person.reservation, [
          "年度",
          "身分證字號",
        ]),
        data: _.pickBy(this.payload, (o) => o),
      };
      await axios.post("/station", data);
      this.$toast.success("送出完成");
      this.$router.push(`/station/scan`);
    },
    goStation() {
      if (this.person.reservation) {
        this.$router.push(`/station/${this.stationPath}`);
      } else {
        this.$toast.error("本場次無此民眾資料！");
      }
    },
  },
};
</script>
